import SecondPageFile from './SecondPageFile';
export default SecondPageFile;
